import { render, staticRenderFns } from "./FrameHeader.vue?vue&type=template&id=e612128c&"
import script from "./FrameHeader.vue?vue&type=script&lang=js&"
export * from "./FrameHeader.vue?vue&type=script&lang=js&"
import style0 from "./FrameHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports